import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/axiosConfig";
import { OPERDON_DELET } from "../../constant-value";

// AsyncThunk برای حذف اپردون
export const deleteOperdon = createAsyncThunk(
  "operdonDelete/deleteOperdon",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/${OPERDON_DELET}/${id}`);
      return id; // برگردوندن id اپردون حذف شده
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const operdonDelSlice = createSlice({
  name: "operdonDelete",
  initialState: {
    isLoading: false,   // وضعیت در حال اجرا
    isSuccess: false,   // حذف موفق بود یا نه
    error: null,        // خطای حذف
  },
  reducers: {
    // ریست کردن state بعد از استفاده
    resetDeleteState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteOperdon.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(deleteOperdon.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(deleteOperdon.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload || "خطا در حذف اپردون";
      });
  },
});

// اکشن‌ها
export const { resetDeleteState } = operdonDelSlice.actions;

// سلکتورها
export const selectDelLoadingOperdonState = (state) => state.operdonDelete.isLoading;
export const selectDelSuccessOperdonState = (state) => state.operdonDelete.isSuccess;
export const selectDelErrorOperdonState = (state) => state.operdonDelete.error;

export default operdonDelSlice.reducer;
